import Image from 'next/image';
import styled from 'styled-components';
import { rgbDataURL } from 'utils';
import { ComponentProps } from 'react';
import { cloudFlareLoader, getShimmerBase64 } from '../../utils/images';

export default function NextImageWithShimmer(props: ComponentProps<typeof Image>) {
  const { loader, alt } = props;

  return (
    <StyledImage
      alt={alt || ''}
      placeholder={getShimmerBase64(100, 100)}
      blurDataURL={rgbDataURL(0, 0, 0)}
      loader={loader || cloudFlareLoader}
      {...props}
    />
  );
}

const StyledImage = styled(Image)`
  filter: initial !important;
`;
